'use strict';

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var notify = require('notify');
var bodyStateDetection = require('body-state-detection');
var domCache = require('dom-cache');

var dom;

var setupDom = function() {

	dom = {};

};

var addEventHandlers = function() {

	domCache.document.on('mouseover', '[data-popup-markup]', showPricingBanner);
	domCache.document.on('mouseout', '[data-popup-markup]', hidePricingBanner);

};

var showPricingBanner = function() {

	var state = bodyStateDetection.getState();
	var position = 'top';

	if (state.indexOf('large') >= 0) {
		position = 'right';
	}

	notify.show({
		msg: $(this).attr('data-popup-markup'),
		target: $(this),
		customClasses: 'savings-popup',
		position: position
	});

};

var hidePricingBanner = function() {

	notify.hide();

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
};